// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchExercises_searchInput__iFVbI"};